'use client';
import Error from '@/assets/icons/defaultImage/error.svg';
import { useTranslation } from '@/i18n/client';
import { Button } from '@mui/material';
import cn from 'clsx';
import styles from './index.module.scss';
import { useEffect } from 'react';
import {
  commonBusinessLogger,
  COMMON_EVENT_NAMES,
  PageName,
} from '@/utils/logger/instance/commonBusinessLogger';

//页面样式
export enum PageNothingLayout {
  ROW = 'row',
  COLUMN = 'column',
}

interface TrackParms {
  exptag?: string;
  exptagConfig?: string;
  exptagJsonParam?: any;
}

interface LoggerInfo {
  page: PageName;
  message?: Record<string, string | number | boolean>;
}
interface LoadingIconProps {
  layout?: PageNothingLayout; // row | column
  text?: string;
  btnText?: string;
  style?: React.CSSProperties;
  textStyle?: React.CSSProperties;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clickTryAgain?: (...args: any[]) => void;
  defaultImageWidth?: number; // 默认图片宽度
  defaultImageHeight?: number; // 默认图片高度
  trackParms?: TrackParms;
  loggerInfo?: LoggerInfo; // 是否上报logger
}

const UKPageError = ({
  layout = PageNothingLayout.COLUMN,
  text,
  btnText,
  className,
  style,
  textStyle,
  clickTryAgain = () => window.location.reload(),
  defaultImageWidth = 120,
  defaultImageHeight = 120,
  trackParms,
  loggerInfo,
}: LoadingIconProps) => {
  const { t } = useTranslation();

  const { exptag, exptagConfig, exptagJsonParam } = trackParms || {};
  const expTagProps = exptag
    ? {
        exptag,
        'data-exptag-config': exptagConfig ? exptagConfig : undefined,
        'data-exptag-json-param': exptagJsonParam ? exptagJsonParam : undefined,
      }
    : {};

  useEffect(() => {
    if (loggerInfo && loggerInfo?.page) {
      commonBusinessLogger({
        eventName: COMMON_EVENT_NAMES.PAGE_ERROR_COMPONENT_SHOW,
        category: {
          page: loggerInfo?.page,
        },
        message: loggerInfo?.message,
      });
    }
  }, [loggerInfo]);

  return (
    <div className={cn(styles.pageError, className)} style={style}>
      <div className={cn(layout === PageNothingLayout.ROW ? styles.row : styles.column)}>
        <Error width={defaultImageWidth} height={defaultImageHeight} />
        <span className={styles.pageErrorText} style={textStyle}>
          {text ? text : t ? t('common.pageStatus.error') : ''}
        </span>
      </div>
      <div {...expTagProps}>
        <Button className={styles.btn} variant='outlined' onClick={clickTryAgain}>
          {btnText ? btnText : t ? t('common.btnText.tryAgain') : ''}
        </Button>
      </div>
    </div>
  );
};

export default UKPageError;
